import { msg } from '@lingui/core/macro';

import { defineEnum } from '@/shared/patterns/define-enum';

import { STATUS_VALUES } from './pix-med.constants';

// Rótulos traduzidos pelo valor técnico (U33), com tom e ícone (U19). Legado: `statusEnum`
// (`pages/BankAccount/PixMedAdmin/constants.ts:10-18`), onde a cor era o único canal.

/** Status da contestação. `UNKNOWN` é o "Desconhecido" do legado para ausente ou fora do mapa. */
export const PIX_MED_STATUS = defineEnum(
  {
    IN_ANALYSIS: { label: msg`Em Análise`, tone: 'info', icon: 'hourglass' },
    APPROVED: { label: msg`Aprovada`, tone: 'ok', icon: 'circle-check' },
    PARTIALLY_REFUNDED: { label: msg`Valor devolvido parcialmente`, tone: 'warn', icon: 'rotate-ccw' },
    FULLY_REFUNDED: { label: msg`Valor devolvido integralmente`, tone: 'ok', icon: 'check-check' },
    REJECTED: { label: msg`Recusada`, tone: 'err', icon: 'circle-x' },
    DEADLINE_EXPIRED: { label: msg`Prazo encerrado`, tone: 'neutral', icon: 'clock' },
    UNKNOWN: { label: msg`Desconhecido`, tone: 'neutral', icon: 'circle-dashed', hidden: true },
  },
  { order: [...STATUS_VALUES, 'UNKNOWN'] },
);

/** Tipo de contestação do filtro (`PixMedAdminForm.tsx:19-22`); o valor vai numérico no fio. */
export const PIX_MED_CONTESTATION_TYPE = defineEnum(
  {
    '1': { label: msg`Contestação realizada` },
    '2': { label: msg`Contestação recebida` },
  },
  { numeric: true, order: ['1', '2'] },
);
